import { render, staticRenderFns } from "./OrganizationCardSectionProvidableVehicles.vue?vue&type=template&id=1f472016&"
import script from "./OrganizationCardSectionProvidableVehicles.vue?vue&type=script&lang=js&"
export * from "./OrganizationCardSectionProvidableVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports